module.exports = "/img/age_verification.gif?a2af92e9ea1705a37839c3eadefa3826";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/age_verification.gif
// module id = 8m+Y
// module chunks = 57